import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  ApiRef,
  BackstageIdentityApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  OAuthApi,
  oauthRequestApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  useApp,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { catalogApiRef, entityPresentationApiRef } from '@backstage/plugin-catalog-react';
import { DefaultEntityPresentationApi } from '@backstage/plugin-catalog';

export const oktaAuthApiRef: ApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({
  id: 'auth.okta',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: oktaAuthApiRef as any,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        environment: configApi.getOptionalString('auth.environment'),
        provider: {
          id: 'okta',
          title: 'Okta',
          icon: () => null,
        },
        defaultScopes: ['openid', 'profile', 'email'],
      }),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: entityPresentationApiRef,
    deps: { catalogApi: catalogApiRef },
    factory: ({ catalogApi }) => {
      return DefaultEntityPresentationApi.create({
        catalogApi,
        kindIcons: {
          azureenvironment: useApp().getSystemIcon('kind:domain')!,
          azureenvironmentprovider: useApp().getSystemIcon('kind:system')!,
          awsenvironment: useApp().getSystemIcon('kind:domain')!,
          awsenvironmentprovider: useApp().getSystemIcon('kind:system')!,
        },
      });
    },
  }),
  ScmAuth.createDefaultApiFactory(),
];
